export default __webpack_public_path__ + "static/media/tts_en_alph_a2(-10).ef531624.mp3";